import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";
import { NOTIFICATIONS_API } from "../notifications.constants";

export function useNotificationReadMutation() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (id: number) => {
      return apiRequest(`${NOTIFICATIONS_API}${id}/read/`, "POST");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });

  return mutation;
}

export default useNotificationReadMutation;
